export const FORM_NAMES = {
  CUSTOMER_FORM: 'customerForm',
  CUSTOMER_ADDRESS_FORM: 'customerAddressForm',
  NON_CUSTOMER_FORM: 'nonCustomerForm',
  FORM_VALIDATION: 'formValidation',
};
